angular.module("SupportAgent")
.controller(
 'MpacterController',
 ['$scope','$rootScope','$filter',
 function ($scope,$rootScope,$filter) {
  $scope.getLastMessage = function(conversation) {
   var index =conversation.m.indexOf($filter('filter')(conversation.m, {t: conversation.lm})[0]);
   return (index!=-1)?conversation.m[index].msg:"";
  };
     $rootScope.menutitle = "Mpacter";
  
 }]);
/* vim:set ts=8 sw=1 expandtab: */
